module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/shared/layout/app-layouts/empty-layout.component.html
// module id = ../../../../../src/app/shared/layout/app-layouts/empty-layout.component.html
// module chunks = main